import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WelcomeScreen from "./WelcomeScreen";
import { isIntroSeen } from "./OnboardingIntro";

/**
 * 첫 진입(온보딩 시작) 화면 — /login 라우트.
 * 순수 프레젠테이션 컴포넌트 WelcomeScreen에 라우팅 콜백만 주입하는 wrapper.
 * - onStart → 회원가입/시작(휴대폰번호 입력)
 * - onLogin → 다른 방법으로 계속하기(소셜 로그인 선택)
 *
 * 앱 웹뷰는 Splash(`/`)를 안 거치고 여기(`/login`)로 바로 진입하므로,
 * 온보딩 미열람이면 여기서도 최초 1회 온보딩으로 보낸다.
 */
const Welcome: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isIntroSeen()) {
      navigate("/onboarding-intro", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WelcomeScreen
      onStart={() => navigate("/register/phone")}
      onLogin={() => navigate("/login/social")}
    />
  );
};

export default Welcome;
